import DriveFolderUploadOutlined from "@mui/icons-material/DriveFolderUploadOutlined";
import { Grid, IconButton, Typography } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import React from "react";
import { FontFamilySwitch } from "../../utils";
const useStyles = makeStyles((theme) => ({
  gridContainer: {
    marginBottom: theme.spacing(2),
  },
  root: {
    width: "100%",
    height: "100%",
    "& input": {
      position: "absolute",
      width: "100%",
      height: "100%",
      opacity: 0,
      left: 0,
      cursor: "pointer",
      zIndex: 10000,
    },
    "& .MuiButton-root": {
      top: "80px",
    },
    "& .MuiTypography-colorPrimary": {
      marginTop: theme.spacing(11),
    },
  },
  drap: {
    position: "relative",
    height: "159px",
    borderRadius: 10,
    textAlign: "center",
    background: "#DEEAFC",
  },
  drap2: {
    position: "relative",
    height: "159px",
    borderRadius: 10,
    textAlign: "center",
    background: "#DEEAFC",
  },
  text: {
    color: "#5078E1",
    fontSize:"0.75rem",
    padding: 10,
    fontFamily: FontFamilySwitch().semiBold,
  },
  text2: {
    color: "#5078E1",
    fontSize:"0.75rem",
    padding: 10,
    fontFamily: FontFamilySwitch().semiBold,
  },
  upload: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column",
    marginTop: "30px",
  },
}));

export const Upload2 = (props) => {
  const classes = useStyles(props);
  return (
    <Grid
      container
      direction="row"
      justify="center"
      alignItems="center"
      className={classes.gridContainer}
    >
      <Grid item xs={12}>
        <div className={classes.drap}>
          <div className={classes.root}>
            <div className={classes.upload}>
              {props?.single && (
                <input
                  type="file"
                  onChange={(e) => props.onChange(e)}
                  disabled={props.disabled}
                />
              )}

              {!props?.single && (
                <input
                  type="file"
                  multiple
                  onChange={(e) => props.onChange(e)}
                  disabled={props.disabled}
                />
              )}
              <IconButton>
                <DriveFolderUploadOutlined
                  style={{ fontSize: "58px", color: "#5078E1" }}
                />
              </IconButton>
              <Typography className={classes.text}>Upload File</Typography>
            </div>
          </div>
        </div>
      </Grid>
    </Grid>
  );
};
